import { Slide, Slider as SliderCarousel } from 'pure-react-carousel';
import type { Image as ImageType } from 'types/capi/shared';

import Image from '~/components/Image';

type Props = { gallery: ImageType[]; pad: boolean };

const Slider = ({ gallery, pad }: Props) => {
  return (
    <SliderCarousel>
      {gallery.map(({ url, alt }, index) => (
        <Slide key={index} index={index}>
          <div className="flex items-center justify-center rounded-xl">
            <Image
              loading={index === 0 ? 'eager' : undefined}
              pad={pad}
              src={url}
              alt={alt}
              height={672}
              width={672}
              responsiveOptions={{
                lg: { height: 1000, pad, width: 1000 },
                md: { height: 768, pad, width: 768 },
                sm: { height: 672, pad, width: 672 },
                xl: { height: 1024, pad, width: 1024 }
              }}
            />
          </div>
        </Slide>
      ))}
    </SliderCarousel>
  );
};

export default Slider;
